var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.3284 10.6357H7.53221C7.16184 10.6357 6.8606 10.9418 6.8606 11.318C6.8606 11.6949 7.16184 12.0002 7.53221 12.0002H11.3284C11.6988 12.0002 12 11.6949 12 11.318C12 10.9418 11.6988 10.6357 11.3284 10.6357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87268 2.60306L8.46992 5.50978C8.5567 5.5793 8.57151 5.70686 8.50379 5.79573L4.23916 11.3526C3.97108 11.6959 3.57601 11.8901 3.15272 11.8973L0.82464 11.9259C0.700476 11.9274 0.591832 11.8414 0.563613 11.7181L0.0345032 9.41767C-0.0572092 8.99484 0.0345031 8.55769 0.302585 8.22086L4.58837 2.63746C4.65751 2.54787 4.7852 2.53211 4.87268 2.60306Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0804 3.77745L9.38687 4.64316C9.31703 4.73131 9.19145 4.74564 9.10468 4.67541C8.26163 3.99316 6.10287 2.24239 5.50391 1.75721C5.41643 1.68555 5.40444 1.55799 5.47499 1.46912L6.14378 0.638526C6.7505 -0.142621 7.80871 -0.214285 8.66234 0.466531L9.64296 1.24768C10.0451 1.563 10.3132 1.97866 10.4049 2.41581C10.5107 2.89669 10.3978 3.36896 10.0804 3.77745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8de33e98b25314fa6229e17c0fc373f8.svg";
export { ForwardRef as ReactComponent };